import type { FC } from "react"
import { useState, useCallback } from "react"
import classNames from "classnames"
import { TreeSelect } from "antd"
import { CaretDownOutlined } from "@ant-design/icons"
import type { AreaItemVO } from "@/api"
import { getAllParentIds } from "@/util/util"
import "./index.scss"
// ==============================================
const fieldNames = {
  value: "areaCode",
  label: "areaName",
  children: "children",
}
// ==============================================
interface AreaSelectProps {
  // 当前值
  value?: number | string
  // tree数据
  options: AreaItemVO[]
  // class
  className?: string
  // placeholder
  placeholder?: string
  // 切换值
  onChange?: (areaId: number) => void
}
const AreaSelect: FC<AreaSelectProps> = ({
  className = "",
  placeholder = "请选择区域范围",
  value,
  options = [],
  onChange,
}) => {
  const [expandedKeys, setExpandedKeys] = useState<(number | string)[]>(value ? [value] : [])

  // 展示节点时调用
  const onTreeExpand = useCallback(
    (expandedKeys) => {
      setExpandedKeys(expandedKeys)
    },
    [setExpandedKeys],
  )

  // 展开下拉菜单的回调
  const onDropdownVisibleChange = useCallback(
    (open) => {
      if (open) {
        const keys: any[] = value ? getAllParentIds(options, value, fieldNames.value) || [] : []
        setExpandedKeys(keys)
      }
    },
    [value, options],
  )

  return options.length ? (
    <div className={classNames("header-area-select", className)}>
      <div className="info-right">
        <CaretDownOutlined className="info-right-icon" />
        <TreeSelect
          className="theme-tree-select"
          popupClassName="theme-tree-select-dropdown"
          treeDefaultExpandAll={false}
          placement="bottomRight"
          placeholder={placeholder}
          dropdownStyle={{ maxHeight: 400, overflow: "auto" }}
          treeExpandedKeys={expandedKeys}
          value={value as any}
          treeData={options}
          fieldNames={fieldNames}
          onChange={onChange}
          onTreeExpand={onTreeExpand}
          onDropdownVisibleChange={onDropdownVisibleChange}
        />
      </div>
    </div>
  ) : null
}

export default AreaSelect
